import type { CSSProperties } from 'react';
import Logo from 'src/assets/logo.svg';

export const AppLoadingSurface = () => (
    <div className="app-loading-surface">
        <div className="app-loading-lockup" role="status" aria-label="Loading ResQ">
            <span
                className="app-loading-logo"
                role="img"
                aria-label="ResQ"
                style={{ '--app-loading-logo': `url("${Logo}")` } as CSSProperties}
            >
                <img className="app-loading-logo-image" src={Logo} alt="" aria-hidden />
            </span>
            <div className="app-loading-spinner" aria-hidden="true" />
        </div>
    </div>
);
